export const comingSoonDiscontinueDates = (product: any) => {
    let isComingSoon = false;
    let isDiscontinued  = false;
    if(product.properties) {
        const customActivateOn = product.properties?.customActivateOn;
        const customDeactiveOn = product.properties?.customDeactiveOn;
        const currentDay = new Date();

        if(customActivateOn !== null && customActivateOn !== "") {
            isComingSoon = new Date(customActivateOn) > currentDay;
        }
        if(customDeactiveOn !== null && customDeactiveOn !== "") {
            isDiscontinued = new Date(customDeactiveOn) > currentDay;
        }
    }
    return {
        isComingSoon,
        isDiscontinued
    }
}